import { render } from "./NewSlotModal.vue?vue&type=template&id=33d06b4d"
import script from "./NewSlotModal.vue?vue&type=script&lang=js"
export * from "./NewSlotModal.vue?vue&type=script&lang=js"

import "./NewSlotModal.vue?vue&type=style&index=0&id=33d06b4d&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__